import { fmtDate } from "@/lib/api";

const money = (v, cur) => (v === null || v === undefined ? "—" : `${cur} ${Number(v).toLocaleString(undefined, { maximumFractionDigits: 1 })}b`);
const each = (v, cur, pop) => (v === null || v === undefined || !pop ? "—" : `${cur} ${Math.round((v * 1e9) / pop).toLocaleString()}`);

const Table = ({ title, rows, total, cur, color, testid, pop }) => {
  const sum = total || rows.reduce((a, r) => a + (r.amount || 0), 0) || 1;
  return (
    <div className="rounded-2xl border border-border bg-white p-4" data-testid={testid}>
      <p className="text-sm font-semibold">{title}</p>
      <table className="mt-1 w-full text-sm">
        <thead><tr className="text-right text-[11px] uppercase tracking-wider text-slate-400"><th /><th className="pb-1 pl-3 font-medium">Total</th>{pop && <th className="pb-1 pl-3 font-medium">Per person</th>}</tr>
        <tr className="font-semibold"><td className="py-1.5 pr-2">All</td>
          <td className="whitespace-nowrap py-1.5 pl-3 text-right" data-testid={`${testid}-total`}>{money(total, cur)}</td>
          {pop && <td className="whitespace-nowrap py-1.5 pl-3 text-right" data-testid={`${testid}-total-per-person`}>{each(total, cur, pop)}</td>}
        </tr></thead>
        <tbody>{rows.map((r, i) => (
          <tr key={`${r.category}-${i}`} className="border-t border-border" data-testid={`${testid}-row-${i}`}>
            <td className="py-1.5 pr-2"><span className="block">{r.category}</span>
              {r.amount != null && <span className="mt-1 block h-1.5 rounded-full bg-slate-100"><span className={`block h-1.5 rounded-full ${color}`} style={{ width: `${Math.min(100, (r.amount / sum) * 100)}%` }} /></span>}</td>
            <td className="whitespace-nowrap py-1.5 pl-3 text-right align-top font-medium">{money(r.amount, cur)}</td>
            {pop && <td className="whitespace-nowrap py-1.5 pl-3 text-right align-top text-slate-600" data-testid={`${testid}-row-${i}-per-person`}>{each(r.amount, cur, pop)}</td>}
          </tr>))}</tbody></table>
    </div>
  );
};

export const BudgetTables = ({ o, approvedAt, word = "federal", population }) => {
  const pop = population?.value;
  return (
    <div className="space-y-2" data-testid="budget-tables">
      <div className="flex flex-wrap items-baseline gap-2">
        <p className="flex-1 font-serif text-xl">{word === "federal" ? "Federal" : "National"} budget {o.fiscal_year}</p>
        <a href={o.document.url} target="_blank" rel="noreferrer" className="text-xs text-[hsl(var(--facts))] hover:underline" data-testid="budget-document-link">{o.document.title || "Official budget papers"}</a>
      </div>
      <div className="grid gap-3 lg:grid-cols-2">
        <Table title="Spending by category" rows={o.spending} total={o.total_spending} cur={o.currency} color="bg-rose-400" testid="budget-spending" pop={pop} />
        <Table title="Revenue by source" rows={o.revenue} total={o.total_revenue} cur={o.currency} color="bg-emerald-500" testid="budget-revenue" pop={pop} />
      </div>
      <p className="text-[11px] text-slate-500">Estimates in billions of {o.currency}, as published in the official budget papers. Checked by Middle's editors{approvedAt && ` on ${fmtDate(approvedAt)}`}.
        {pop && <span data-testid="budget-per-person-note"> Per person: each amount divided by the population of {Number(pop).toLocaleString()} ({population.source}, {population.year}).</span>}</p>
    </div>
  );
};
